// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"ErrorBoundary_errorWrapper__q0jAO","error":"ErrorBoundary_error__10M1y"};